import { Box, Button, IconButton, makeStyles, MenuItem, TextField, withStyles } from '@material-ui/core'
import { ClearAllOutlined, Filter2Outlined, SearchOutlined } from '@material-ui/icons'
import FilterIcon from '../../assets/images/FilterIcon.png'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { filterProjects, searchProject } from '../../redux/actions/projectAction'
import { setCurrentArchiveFilter } from '../../redux/actions/archiveFilterAction'


const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: "flex",
        flexDirection: "row",
        // justifyContent:"space-between",
        flexWrap:"wrap",
        gap: theme.spacing(4),
        alignItems: "center",
        padding: theme.spacing(4),
        justifyContent:"space-between"
    },
    projectFilter: {
        width: '240px'
    },
    projectSearch: {
        width: '380px'
    }
}))
const MuiMenuItem = withStyles((theme) => ({
    root: {
        "&$selected": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiMenuItemIcon-root": {
                color: "white"
            }
        },
        "&$selected:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiMenuItemIcon-root": {
                color: "white"
            }
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "& .MuiSvgIcon-root": {
                color: "white !important"
            }
        }
    },
    selected: {}
}))(MenuItem);


const ProjectActions = ({ handleFilter }) => {
    const classes = useStyles()
    const [filterValue, setFilterValue] = useState("all")    
    const dispatch = useDispatch()


    const handleFilterChange = (event) => {
        setFilterValue(event.target.value)
        dispatch(setCurrentArchiveFilter(event.target.value))
    }

    const handleSearch = (event) => {
        const searchQuery = event.target.value;
        dispatch(searchProject(searchQuery))
    }

    const archiveFilterData = useSelector((state) => state.archiveFilterReducer)

    return (
        <Box className={classes.wrapper}>
            <TextField InputProps={{
                startAdornment: (
                    <IconButton size="small">
                        <img height={16} src={FilterIcon} />
                    </IconButton>
                )
            }} className={classes.projectFilter} placeholder="Project Filter" select={"true"} margin="none" size="small" variant="outlined" name="filter" value={filterValue} onChange={handleFilterChange}>
                <MuiMenuItem value={"all"}>
                    All Projects ({archiveFilterData.count.all ?? 0})
                </MuiMenuItem>
                <MuiMenuItem value={"unarchive"}>
                    Active ({archiveFilterData.count.unarchive ?? 0})
                </MuiMenuItem>
                <MuiMenuItem value={"archive"}>
                    Archived ({archiveFilterData.count.archive ?? 0})
                </MuiMenuItem>
                <MuiMenuItem value={"completed"}>
                    Completed ({archiveFilterData.count.completed ?? 0})
                </MuiMenuItem>
            </TextField>
            <TextField onChange={handleSearch} name="search" InputProps={{
                startAdornment: (
                    <IconButton size="small">
                        <SearchOutlined />
                    </IconButton>
                ),
            }} className={classes.projectSearch} size="small" variant="outlined" placeholder="Search for a project" />
            {/* <Button variant="contained" color="primary">
                <ClearAllOutlined fontSize='small'/>
                Clear Filters
            </Button> */}
        </Box>
    )
}

export default ProjectActions